module.exports = __webpack_public_path__ + "cd-socials.5b392ee2328d3c2dc0d2.svg";


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/assets/full-screen-pop-out-navigation/img/cd-socials.svg
// module id = ../../../../../src/assets/full-screen-pop-out-navigation/img/cd-socials.svg
// module chunks = 2